import React, { ReactElement } from "react";
import { Box, MainTitle, PressableOpacity } from "app/components/common";
import { useNavigation } from "@react-navigation/native";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

interface IProps {
  title: string;
  leftIcon?: ReactElement | false;
  callbackOnPressLeft?: () => void;
}

const CertificateHeader = ({
  title,
  leftIcon,
  callbackOnPressLeft,
}: IProps) => {
  const navigation = useNavigation();

  const pressedLeftIcon = () => {
    if (!callbackOnPressLeft) {
      navigation.goBack();
    } else {
      callbackOnPressLeft();
    }
  };

  return (
    <Box
      alignSelf="flex-start"
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      marginBottom="xs"
      width="100%"
    >
      {leftIcon && (
        <Box alignItems="center" marginRight="xs">
          <PressableOpacity onPress={pressedLeftIcon}>
            {leftIcon}
          </PressableOpacity>
        </Box>
      )}

      <MainTitle
        variant={isWebDesktop ? "l10-bold" : "l8-bold"}
        color="neutral.white"
      >
        {title}
      </MainTitle>
    </Box>
  );
};

export default CertificateHeader;
